<template>
  <v-data-table
    style="background: transparent;"
    :headers="headers"
    :items="syslog"
    hide-default-footer
    :loading="loading"
    id="table_syslog"
    mobile-breakpoint=""
  >
    <template
      v-if="syslog.length"
      #body="{ items }"
    >
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            <span class="font-weight-medium">{{ item }}</span>
          </td>
          <td>
            <v-row no-gutters justify="end">
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn icon v-on="on" @click="deleteIp(item)">
                    <v-icon>
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $tc('remove') }}
                </span>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-else>
      <td>
        {{ $t('$vuetify.noDataText') }}
      </td>
    </template>
  </v-data-table>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: this.$tc('ip'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$tc('action', 2),
          align: 'right',
          sortable: false,
          value: null
        }
      ]
    }
  },
  computed: {
    syslog () {
      return this.$store.state.hsm.netInfo.syslog
    }
  },
  methods: {
    deleteIp (ip) {
      this.$emit('deleteIp', { ip })
    }
  }
}
</script>
